module.exports = __webpack_public_path__ + "80548e7359194c73bf1e75bd2b2c6bd2.svg";